import { useState } from 'react';
import { router, useLocalSearchParams } from 'expo-router';
import { type Weekday } from '@hogar/shared';
import { Button, ErrorText, Field, Label, Screen, useT } from '../components/ui';
import { BackHeader } from '../components/BackHeader';
import { DaysPicker, TimeStepper } from '../components/forms';
import { api } from '../lib/api';
import { useAction } from '../lib/session';
import { useHouse } from '../lib/house';

/**
 * House name, work days, and hours; or, with ?crew=garden, the garden's own days and hours. The end
 * time decides when that day's report is final.
 */
export default function HouseEdit() {
  const { crew } = useLocalSearchParams<{ crew?: string }>();
  const garden = crew === 'garden';
  const { t, lang } = useT();
  const { household } = useHouse();
  const act = useAction();
  const start = garden ? household.garden : household;
  const [name, setName] = useState(household.name);
  const [workDays, setWorkDays] = useState<Weekday[]>(start.workDays);
  const [workStart, setWorkStart] = useState(start.workStart);
  const [workEnd, setWorkEnd] = useState(start.workEnd);
  const [error, setError] = useState('');

  const save = async () => {
    try {
      const fields = garden ? { gardenDays: workDays, gardenStart: workStart, gardenEnd: workEnd } : { name: name.trim(), workDays, workStart, workEnd };
      await act(() => api('PATCH', '/household', fields));
      router.canGoBack() ? router.back() : router.replace('/mas');
    } catch {
      setError(t('errGeneric'));
    }
  };

  return (
    <Screen>
      <BackHeader title={garden ? t('gardenDaysHours') : t('house')} fallback="/mas" />
      {!garden && (
        <>
          <Label>{t('houseName')}</Label>
          <Field value={name} onChange={setName} />
        </>
      )}
      <Label>{t('days')}</Label>
      <DaysPicker value={workDays} onChange={setWorkDays} lang={lang} />
      <Label>{t('startTime')}</Label>
      <TimeStepper value={workStart} onChange={setWorkStart} />
      <Label>{t('endTime')}</Label>
      <TimeStepper value={workEnd} onChange={setWorkEnd} />
      <ErrorText>{error}</ErrorText>
      <Button label={t('save')} onPress={save} disabled={!name.trim() || workDays.length === 0 || workEnd <= workStart} style={{ marginTop: 22 }} />
    </Screen>
  );
}
